import { render } from "./UserHp.vue?vue&type=template&id=0b1a386f"
import script from "./UserHp.vue?vue&type=script&lang=js"
export * from "./UserHp.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Miftah Faridl\\Documents\\KIM-APPS\\motul-web-report\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__